<template>
  <div style="height: 100%;">
    <div v-if="!isLoading && $route.name === 'SettingsMedication'">
      <mu-card-header
        titleClass="largeTitle boldTitle"
        :title="title"
        :subTitle="subTitle"
      >
      </mu-card-header>
      <mu-list style="padding-top: 0">
        <mu-card-text>
          <mu-row>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-raised-button
                class="large"
                :to="{'name': 'SettingsAddMedications'}"
                rippleColor="#F6F6F6"
                fullWidth
                :label="$t('message.medicationPreferencesAdd')"
                secondary
              ></mu-raised-button>
            </mu-col>
          </mu-row>
        </mu-card-text>
        <div v-if="medications.length > 0">
          <mu-list-item
            disableRipple v-for="item, index in activeMedications"
            :key="'medication-active-' + index"
            :title="item.treatment_name"
            :describeText="item.defaultDosage + ' ' + item.unit_label + ' ' + item.frequency_label.toLowerCase()"
            v-bind:class="{odd: index % 2 === 0}"
          >
            <mu-icon-menu
              :anchorOrigin="rightTop"
              :targetOrigin="rightTop"
              :scroller="scroller"
              slot="right"
              icon="more_vert"
              desktop
            >

              <mu-menu-item
                leftIcon="edit"
                :title="$t('message.editText')"
                @click.native="editMedication(item)"
              >
              </mu-menu-item>
              <mu-menu-item
                v-if="item.active === true"
                leftIcon="visibility_off"
                :title="$t('message.disableText')"
                @click.native="disableMedication(item)"
              >
              </mu-menu-item>
            </mu-icon-menu>
            <div slot="default" v-if="item.editMode"></div>
          </mu-list-item>
          <mu-content-block style="border-left: 4px solid #3d8517" v-if="inActiveMedications.length > 0">
            {{$t('message.medicationsPreferencesNotTaking')}}
          </mu-content-block>
          <mu-list-item
            disableRipple v-for="item, index in inActiveMedications"
            :key="'medication-inactive-' + index"
            :title="item.treatment_name"
            :describeText="item.defaultDosage + ' ' + item.unit_label + ' ' + item.frequency_label.toLowerCase()"
            v-bind:class="{odd: index % 2 === 0}"
          >
            <mu-icon-menu
              :anchorOrigin="rightTop"
              :targetOrigin="rightTop"
              :scroller="scroller"
              slot="right"
              icon="more_vert"
              desktop
            >
              <mu-menu-item
                leftIcon="edit"
                :title="$t('message.editText')"
                @click.native="editMedication(item)"
              >
              </mu-menu-item>
              <mu-menu-item
                v-if="item.active === false"
                leftIcon="visibility"
                :title="$t('message.enableText')"
                @click.native="enableMedication(item)"
              >
              </mu-menu-item>
            </mu-icon-menu>
            <div slot="default" v-if="item.editMode"></div>
          </mu-list-item>
        </div>

      </mu-list>
    </div>
    <mu-flexbox v-if="isLoading" justify="center center" align="center center" style="height: 316px;">
      <mu-flexbox-item align="center">
        <mu-circular-progress :size="46"></mu-circular-progress>
        <br/>
        <span v-text="$t('message.loadingText')"></span>
      </mu-flexbox-item>
    </mu-flexbox>
    <router-view></router-view>
  </div>
</template>
<script>

  import MedicationApi from '../../api/Tracking/Medication'
  import ScrollerMixin from '../../mixins/ScrollerMixin'




  export default {
    name: 'settings-medications',
    mixins: [ScrollerMixin],
    data() {
      return {
        title: this.$t('message.medicationPreferencesTitle'),
        subTitle: this.$t('message.medicationPreferencesSubTitle'),
        fullWidth: true,
        model: {},
        medications: [],
        isLoading: true,
        isSaving: false,
        snackbar: false,
        rightTop: {horizontal: 'right', vertical: 'top'}
      }
    },
    watch: {
      '$route': function () {
        let self = this;
        self.loadData();
      }
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/settings/medication');
      self.loadData();
    },
    methods: {
      loadData() {
        let self = this;
        MedicationApi.getUserMedications()
          .then(function (response) {
            const data = response.data;
            self.$nextTick(function () {
              /**
               * Alphabetical ordering
               */
              self.medications = data.sort(function (a, b) {
                let nameA = a.treatment_name.toLowerCase(), nameB = b.treatment_name.toLowerCase();
                if (nameA < nameB)
                  return -1;
                if (nameA > nameB)
                  return 1;
                return 0
              });
              self.isLoading = false;
            });
          })
      },
      editMedication(item) {
        let self = this;
        self.$router.push({
          name: 'SettingsEditMedications',
          params: {
            medication: item
          }
        })
      },
      enableMedication(item) {
        let self = this;
        item.active = true;
        MedicationApi.updateMedication(item).then(function () {
        })
      },
      disableMedication(item) {
        let self = this;
        self.$alert({
          title: self.$t('message.medicationConfirmAlertTitle'),
          text: self.$t('message.medicationConfirmAlertText'),
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            let model = JSON.parse(JSON.stringify(item));
            model.active = false;
            return MedicationApi.updateMedication(model)
          }
        })
          .then(function (response) {
            item.active = false;
            self.$alert({
              title: self.$t('message.medicationConfirmAlertSuccessTitle'),
              text: self.$t('message.medicationConfirmAlertSuccessText'),
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "white"
            })

          }.bind(self))
          .catch(self.$alert.noop);
      },
      handleToggle(item) {
        item.active = !item.active;
        this.$forceUpdate();
      },
      submitForm() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid) {
              self.isSaving = true;
              SettingsApi.putSettings(self.model)
                .then(function (response) {
                  self.showSnackbar();
                  self.isSaving = false;
                  self.$forceUpdate();
                })
                .catch(function (error) {
                  self.isSaving = false;

                })
            }
          })
          .catch(function () {
            self.isSaving = false;
          })
      },
      showSnackbar() {
        this.snackbar = true;
        if (this.snackTimer) clearTimeout(this.snackTimer)
        this.snackTimer = setTimeout(() => {
          this.snackbar = false
        }, 2000)
      },
      hideSnackbar() {
        this.snackbar = false;
        if (this.snackTimer) clearTimeout(this.snackTimer)
      }
    },
    computed: {
      activeMedications() {
        let self = this;
        return self.medications.filter(function (item) {
          return item.active === true;
        });
      },
      inActiveMedications() {
        let self = this;
        return self.medications.filter(function (item) {
          return item.active === false;
        })
      }
    }
  }
</script>
<style scoped>
  .mu-list .odd {
    background: #FAFAFA;
  }
</style>



// WEBPACK FOOTER //
// Medications.vue?716c9c90